const state = {
    token: undefined,
    user: undefined
};

export default state;